import { selectFromReversiblePlanningActionsDto } from '../../models';

export default (undoRedo?: boolean) => (undoRedo
  ? selectFromReversiblePlanningActionsDto()
    .lastUndoablePlanningAction(a => a.actionUuid.actionName.status)
    .nextRedoablePlanningAction(b => b.actionUuid.actionName.status)
    .toString()
  : selectFromReversiblePlanningActionsDto()
    .lastUndoablePlanningAction(a => a.actionUuid.actionName.status)
    .toString());
